import {InsertData } from "../../Hooks/InsertData";
import { GetDataToken } from "../../Hooks/getAllData";
import { CREATE_EMP, ALL_EMP, ADMIN_UPDATE_EMP,All_Const } from "../type";
//create new user
export const createNewEmpAction = (data) => async (dispatch) => {
  try {
    const response = await InsertData(`/api/create-employee/`, data);
    dispatch({
      type: CREATE_EMP,
      payload: response,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: CREATE_EMP,
      payload: e.response,
    });
  }
};
export const gelEmployeesAction = (id) => async (dispatch) => {
  try {
    const response = await GetDataToken(`/api/get-employees/?${id}`);
    dispatch({
      type: ALL_EMP,
      payload: response,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: ALL_EMP,
      payload: e.response,
    });
  }
};
export const gelEmployeesConsultantAction = (id) => async (dispatch) => {
  try {
    const response = await GetDataToken(`/api/get-employees/?user_type=consultant`);
    dispatch({
      type: All_Const,
      payload: response,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: All_Const,
      payload: e.response,
    });
  }
};
export const UpdateEmpAction = (data) => async (dispatch) => {
  try {
    const response = await InsertData(`/api/update-employee/`, data);
    dispatch({
      type: ADMIN_UPDATE_EMP,
      payload: response,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: ADMIN_UPDATE_EMP,
      payload: e.response,
    });
  }
};
